import { render, staticRenderFns } from "./NewProviderAcuInfo.vue?vue&type=template&id=642028da"
import script from "./NewProviderAcuInfo.vue?vue&type=script&lang=js"
export * from "./NewProviderAcuInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports